import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import TagManager from 'react-gtm-module';
import App from './App';

import './index.css';

const tagManagerArgs = {
  gtmId: 'GTM-PT8XG29G', // Replace with your GTM container ID
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
);
